import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { typeMapObj, ADD, REDUCE, REPLACE } from '../correctionApplication/util.js';
import moment from 'moment';
import { correctSure, groupInsuranceBatchSort } from '../request';
export default {
  props: {
    surePageVisible: {
      type: Boolean,
      default: false
    },
    correctionData: {
      type: Array,
      default: () => {}
    },
    effectiveDate: {
      type: String,
      default: ''
    },
    verifyAt: {
      type: String,
      default: ''
    },
    policyPurpose: {
      type: String,
      default: 'other'
    }
  },
  watch: {
    surePageVisible: {
      handler(val) {
        if (val) {
          if (this.policyPurpose === 'groupInsurance') {
            this.columns.splice(1, 0, {
              slots: {
                title: '工种类别'
              },
              dataIndex: 'occupationType',
              key: 'occupationType',
              width: 100,
              align: 'center',
              customRender: (text, record) => {
                return text || '-';
              }
            }, {
              slots: {
                title: '保险方案'
              },
              dataIndex: 'insurancePlanName',
              key: 'insurancePlanName',
              width: 100,
              align: 'center',
              customRender: (text, record) => {
                return text || '-';
              }
            }, {
              slots: {
                title: '劳动合同单位（共同被保险人）'
              },
              dataIndex: 'contractCompany',
              key: 'contractCompany',
              width: 180,
              align: 'center'
            }, {
              slots: {
                title: '实际工作单位（派遣单位）'
              },
              dataIndex: 'dispatchCompany',
              key: 'dispatchCompany',
              width: 180,
              align: 'center'
            });
            this.columns.splice(8, 1);
          }
          let index = 0; //index是为了记录替换关系的两个成员的位置
          this.relatedConnection = [];
          this.safeguard = [];
          this.count = this.correctionData.length;
          this.correctionData.forEach(item => {
            item.recordType = item.type;
            item.effectDate = moment(this.effectiveDate).format('YYYY-MM-DD');
            if (item.type === ADD || item.type === REDUCE) {
              var _item$idNumber;
              index++;
              item.index = index;
              item.effectDate = moment(this.effectiveDate).format('YYYY-MM-DD');
              item.idNumber = ((_item$idNumber = item.idNumber) === null || _item$idNumber === void 0 ? void 0 : _item$idNumber.toLocaleUpperCase()) || '';
              this.dataSource.push(item);
            } else if (item.type === REPLACE) {
              var _item$increase$idNumb, _item$reduce$idNumber;
              let obj = {};
              index++;
              obj.increIndex = index;
              item.increase.index = index;
              item.increase.recordType = item.increase.type;
              item.increase.effectDate = moment(this.effectiveDate).format('YYYY-MM-DD');
              item.increase.idNumber = ((_item$increase$idNumb = item.increase.idNumber) === null || _item$increase$idNumb === void 0 ? void 0 : _item$increase$idNumb.toLocaleUpperCase()) || '';
              this.dataSource.push(item.increase);
              index++;
              obj.index = index;
              item.reduce.recordType = item.reduce.type;
              item.reduce.effectDate = moment(this.effectiveDate).format('YYYY-MM-DD');
              item.reduce.index = index;
              item.reduce.idNumber = ((_item$reduce$idNumber = item.reduce.idNumber) === null || _item$reduce$idNumber === void 0 ? void 0 : _item$reduce$idNumber.toLocaleUpperCase()) || '';
              this.dataSource.push(item.reduce);
              this.relatedConnection.push(obj);
            }
          });
          this.handlerSortData();
          this.pagination.total = this.dataSource.length;
        }
      },
      immediate: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.showDetail = true;
    }, 1000);
  },
  data() {
    const that = this;
    return {
      dataSource: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      relatedConnection: [],
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation',
        width: 100,
        align: 'center'
      }, {
        slots: {
          title: '类型'
        },
        dataIndex: 'recordType',
        key: 'recordType',
        align: 'center',
        width: 110,
        customRender: text => {
          return that.$t(typeMapObj[text]);
        }
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: 'name',
        width: 100,
        align: 'center'
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        width: 200,
        align: 'center'
      }, {
        slots: {
          title: '生效日期'
        },
        dataIndex: 'effectDate',
        key: 'effectDate',
        align: 'center',
        width: 120
      }, {
        slots: {
          title: '保费变化量'
        },
        dataIndex: 'premium',
        key: 'premium',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        align: 'center',
        width: 150,
        ellipsis: true
      }],
      detailContent: '',
      safeguard: [],
      count: 0,
      sortList: {
        increList: [],
        reduceList: [],
        replaceList: []
      },
      premium: 0,
      premiumType: '',
      loading: false,
      showDetail: false,
      addCount: 0,
      delCount: 0,
      replaceCount: 0
    };
  },
  methods: {
    handlerSortData() {
      //处理分类数据
      this.safeguard = [];
      this.premium = 0;
      this.addCount = 0;
      this.delCount = 0;
      this.replaceCount = 0;
      this.correctionData.forEach(item => {
        if (item.type === ADD) {
          this.premium = this.premium + Number(item.premium) * 100;
        } else if (item.type === REDUCE) {
          this.premium = this.premium - Number(item.premium) * 100;
        }
        if (item.type === ADD) {
          this.addCount++;
        } else if (item.type === REDUCE) {
          this.delCount++;
        }
        if (item.type === ADD || item.type === REDUCE) {
          let obj = {
            type: item.type,
            name: item.name,
            idNumber: item.idNumber
          };
          this.safeguard.push(obj);
          let key = item.type === ADD ? 'increList' : 'reduceList';
          this.sortList[key].push(obj);
        } else if (item.type === REPLACE) {
          this.replaceCount++;
          let obj = {
            type: item.type
          };
          obj[ADD] = {
            name: item.increase.name,
            idNumber: item.increase.idNumber
          };
          obj[REDUCE] = {
            name: item.reduce.name,
            idNumber: item.reduce.idNumber
          };
          this.safeguard.push(obj);
          this.sortList.replaceList.push(obj);
        }
      });
      this.premium = Number(this.premium / 100).toFixed(2);
      this.premiumType = this.premium > 0 ? 'INCREASE' : 'REDUCE';
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
    },
    sureSave() {
      if (this.loading) {
        return;
      }
      let personnelDetailsData = [];
      personnelDetailsData = JSON.parse(JSON.stringify(this.dataSource)).map(item => {
        if (item.recordType === REDUCE) {
          item.effectDate = moment(item.effectDate).subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59';
        } else {
          item.effectDate = item.effectDate + ' 00:00:00';
        }
        delete item.index;
        delete item.type;
        delete item.startAt;
        delete item.endAt;
        return item;
      });
      let detail = {
        safeguard: this.safeguard,
        count: this.count,
        premiumType: this.premiumType,
        premium: Math.abs(this.premium),
        addCount: this.addCount,
        delCount: this.delCount,
        replaceCount: this.replaceCount
      };
      let params = {
        policyId: this.$route.params.id,
        detail: JSON.stringify(detail),
        correctEffectiveAt: moment(this.effectiveDate).format('YYYY-MM-DD') + ' 00:00:00',
        personnelDetailsData,
        verifyAt: this.verifyAt
      };
      this.loading = true;
      let sureMethod = this.policyPurpose === 'groupInsurance' ? groupInsuranceBatchSort : correctSure;
      sureMethod(params).then(res => {
        if (res.message === 'success') {
          this.$router.push({
            name: 'customerCorrectionRecord',
            params: {
              id: this.$route.params.id
            }
          });
        } else {
          if (res.code === 510063) {
            this.$confirm({
              title: this.$t('信息提示'),
              content: this.$t('在保人员数据发生改变，请【立即刷新】重新进入该页面'),
              okText: this.$t('立即刷新'),
              cancelButtonProps: {
                style: {
                  display: 'none'
                }
              },
              closeOnClickModal: false,
              onOk: () => {
                this.$router.go(0);
              }
            });
          } else {
            this.$message.error(this.$t(res.message));
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};